/* eslint-disable react/jsx-no-bind */
import React from 'react';
import Sticky from 'react-stickynode';

// @ts-ignore Problema del linter con la version especifica de nextui
import { Navbar } from "@nextui-org/react";
import { SocialIcons } from './SocialIcons';
import { SearchInput } from './SearchInput';
import { ContactInfo } from './ContactInfo';
import { NavigationMenu } from './NavigationMenu';
import { BlogMegaMenu } from './BlogMegaMenu';
import { Logo } from './Logo';
import { ShoppingCart } from './ShoppingCart';
import { BiSearchAlt2 } from "@react-icons/all-files/bi/BiSearchAlt2";

export interface DoubleNavbarProps {
  handleSearchChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  searchValue: string;
  navbarIsSticky: boolean | null;
  setNavbarIsSticky: (value: React.SetStateAction<boolean | null>) => void;
  toggleSearch: () => void;
  toggleRef: React.RefObject<HTMLButtonElement>;
  setMobileSidebarIsOpen: (value: React.SetStateAction<boolean>) => void;
  mobileSidebarIsOpen: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

export const DoubleNavbar = ({
  handleSearchChange,
  searchValue,
  navbarIsSticky,
  setNavbarIsSticky,
  toggleSearch,
  toggleRef,
  setMobileSidebarIsOpen,
  mobileSidebarIsOpen,
  isMobile,
  isTablet,
}: DoubleNavbarProps)  => {
  const [blogMegaMenuIsOpen, setBlogMegaMenuIsOpen] = React.useState<boolean>(false);

  const handleStickyStateChange = (e: { status: any; }) => {
    if (e.status === Sticky.STATUS_FIXED) {
      setNavbarIsSticky(true);
    } else if (e.status === Sticky.STATUS_ORIGINAL || e.status === Sticky.STATUS_RELEASED) {
      setNavbarIsSticky(false);
    }
  }

  const getNavbarClasses = () => {
    const stickyClass = navbarIsSticky ? "tt-header__sticky-navbar--sticky" : "";
    const deviceClass =
      isMobile ? "tt-header__sticky-navbar--mobile" :
        isTablet ? "tt-header__sticky-navbar--tablet" :
          "tt-header__sticky-navbar--desktop";
    return `tt-header__sticky-navbar ${stickyClass} ${deviceClass}`;
  };

  // Función para manejar el cambio del toggle
  const handleToggleChange = (e: React.ChangeEvent<unknown>) => {
    setMobileSidebarIsOpen(!mobileSidebarIsOpen);
  };

  // Crear un único componente que será pasado como children a Sticky
  const StickyContent = () => (
    <React.Fragment>
      <Navbar variant="static">
        <Navbar.Brand>
          <Logo className="w-24 md:w-28 lg:w-32" withLink />
        </Navbar.Brand>
        <Navbar.Content
          enableCursorHighlight
          activeColor="secondary"
          hideIn="sm"
          variant="underline"
        >
          <NavigationMenu
            setBlogMegaMenuIsOpen={setBlogMegaMenuIsOpen}
            blogMegaMenuIsOpen={blogMegaMenuIsOpen}
          />
        </Navbar.Content>
        <Navbar.Content>
          <BiSearchAlt2
            onClick={toggleSearch}
            size="1.5em"
            className={`text-indigo-japones cursor-pointer ${navbarIsSticky || isMobile || isTablet ? "visible" : "invisible"} ${isMobile || isTablet ? "" : "opacity-60 hover:opacity-100 transition-opacity ease-linear"}`}
          />
          <ShoppingCart isMobile={isMobile} isTablet={isTablet} />
          <Navbar.Toggle
            aria-label="toggle navigation"
            onChange={handleToggleChange}
            ref={toggleRef}
            showIn="sm"
          />
        </Navbar.Content>
      </Navbar>
      <BlogMegaMenu isOpen={blogMegaMenuIsOpen} isMobile={isMobile} />
    </React.Fragment>
  );

  return (
    <>
      <Navbar
        variant="static"
        containerCss={{
          '@smMax': {
            display: 'none',
          },
        }}
        disableShadow
      >
        <Navbar.Content>
          <SocialIcons />
        </Navbar.Content>
        <Navbar.Content
          css={{
            "@xsMax": {
              w: "100%",
              jc: "space-between",
            },
          }}
        >
          <Navbar.Item
            css={{
              "@xsMax": {
                w: "100%",
                jc: "center",
              },
            }}
          >
            <SearchInput
              handleSearchChange={handleSearchChange}
              searchValue={searchValue}
              bordered
              color="secondary"
              css={{
                opacity: 0.4,
                '&:hover': {
                  opacity: 1
                },
              }}
            />
          </Navbar.Item>
        </Navbar.Content>
        <Navbar.Content>
          <ContactInfo />
        </Navbar.Content>
      </Navbar>
      <Sticky
        className={getNavbarClasses()}
        top="#wpadminbar"
        innerZ={1000}
        onStateChange={handleStickyStateChange}
      >
        <StickyContent />
      </Sticky>
    </>
  )
}
